<template>
  <div class="styles">
    <h1>Основно заглавие (h1)</h1>
    <br>
    <h2>Подзаглавие (h2)</h2>
    <br>
    <h3>АКЦЕНТНО ЗАГЛАВИЕ (h3)</h3>
    <br>
    <h4>This is a (h4)</h4>
    <br>
    <h5>This is a (h5)</h5>
    <br>
    <h6>This is a (h6)</h6>
    <br>
    <a class="link" href="#">БУТОН (.link)</a>
    <br>
    <p>ХОЛДИНГ КЦМ 2000 е ключов участник в икономическия живот на страната, опериращ в областта на металургията и рудодобива, производството и търговията на концентрати, цветни метали и сплави, технологичен инженеринг и търговия, комплексен индустриален сервиз (p)</p>
    <br>
    <p class="texts">Основен текст (на светъл фон)</p>
    <br>
    <p class="texts text-main-home">Заглавен текст (начална страница)</p>
    <br>
    <p class="texts dark-bg text-light">Основен текст (на тъмен фон)</p>
    <br>
    <p class="texts text-color">Основен цветен текст</p>
    <br>
    <p class="texts text-color-dark">Цветен текст (на светъл фон)</p>
    <br>
    <p class="texts dark-bg text-color-light">Цветен текст (на тъмен фон)</p>
    <br>
    <p class="texts text-accent">Акцентен текст (на светъл фон)</p>
    <br>
    <p class="texts dark-bg text-accent">Акцентен текст (на тъмен фон)</p>
    <br>
    <div>
      <span class="label zn">Zn</span>
      <span class="label pb">Pb</span>
      <span class="label cd">Cd</span>
      <span class="label au">Au</span>
      <span class="label ag">Ag</span>
    </div>
    <div>
      <span class="label zn-light">Zn</span>
      <span class="label pb-light">Pb</span>
      <span class="label cd-light">Cd</span>
      <span class="label au-light">Au</span>
      <span class="label ag-light">Ag</span>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch("dark_header", true);
  }
};
</script>

<style lang="scss" scoped>
.styles {
  @extend %flex-center;
  flex-direction: column;
  min-height: 100vh;
  padding: 20px 20%;
  width: 100%;
}

.styles p {
  text-align: center;
}
.texts {
  padding: 5px;
}
.dark-bg {
  background-color: #0a1f54;
}
.label {
  display: inline-block;
  padding: 10px;
  color: #fff;
  margin: 5px;
}
.zn {
  background-color: $znDark;
}
.zn-light {
  background-color: $znLight;
}
.pb {
  background-color: $pbDark;
}
.pb-light {
  background-color: $pbLight;
}
.cd {
  background-color: $cdDark;
}
.cd-light {
  background-color: $cdLight;
}
.au {
  background-color: $auDark;
}
.au-light {
  background-color: $auLight;
}
.ag {
  background-color: $agDark;
}
.ag-light {
  background-color: $agLight;
}
</style>

